/*!
 *
 *  hero.ts
 *
 */
import loadImages from 'load-images';
export default function () {
    var hero = document.querySelector('.site-header__bg');
    if (hero) {
        loadImages('.site-header__bg__main img, picture.site-header__bg__light > img, img.site-header__bg__light').then(function () {
            hero.classList.add('-loaded');
        });
    }
    ;
}
